export type KycTab = "all" | "pending" | "approved" | "rejected" | "not";

interface StatusTabsProps {
  tab: KycTab;
  onChange: (t: KycTab) => void;
  counts: Record<KycTab, number>;
}

const TABS: { key: KycTab; label: string }[] = [
  { key: "all", label: "All" },
  { key: "pending", label: "Pending Review" },
  { key: "approved", label: "Approved" },
  { key: "rejected", label: "Rejected" },
  { key: "not", label: "Not Submitted" },
];

const base =
  "whitespace-nowrap rounded-md px-4 py-1.5 text-sm font-medium transition-colors cursor-pointer";

export default function StatusTabs({ tab, onChange, counts }: StatusTabsProps) {
  return (
    <div className="rounded-[10px] border border-line bg-card p-1 shadow-card">
      <div className="flex gap-1 overflow-x-auto">
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => onChange(t.key)}
            className={`${base} ${tab === t.key ? "bg-primary-500 text-white" : "text-ink-secondary hover:bg-page hover:text-ink"}`}
          >
            {t.label}
            <span
              className={`ml-2 inline-flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 text-[11px] font-semibold ${
                tab === t.key ? "bg-white/20 text-white" : "bg-[#EFF6FF] text-[#1E40AF]"
              }`}
            >
              {counts[t.key]}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}